import apiService from "@/services/api";
import { getStringDate } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import dayjs from "@/utils/dayjs";

export const useCalendarQuery = ({ startDate }: { startDate: Date }) => {
    const key = `calendar-${dayjs(startDate).tz("America/Sao_Paulo").format("YYYY-MM")}`;
    const query = useQuery({
        queryKey: [key],
        queryFn: async () => {
            const response = await apiService.fetchAvailableDates(startDate);
            return response;
        },
    });

    return query;
};

// Sem cache longo: o bloqueio pode começar a valer enquanto a pessoa está na página.
export const useSalesStatusQuery = (date: Date | null) => {
    const query = useQuery({
        queryKey: ["sales-status", date ? getStringDate(date) : ""],
        queryFn: async () => {
            const response = await apiService.fetchSalesStatus(date!);
            return response;
        },
        enabled: !!date,
        staleTime: 0,
        refetchInterval: 60_000,
    });

    return query;
};

export const useSchedulesQuery = (date: Date | null) => {
    const query = useQuery({
        queryKey: ["calendar-schedules", date ? getStringDate(date) : ""],
        queryFn: async () => {
            const response = await apiService.fetchDateSchedules(date!);
            return response;
        },
        enabled: !!date,
    });

    return query;
};
